<script setup>

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import {nextTick, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import axios from "axios";
import BlogsEmail from "@/components/BlogsEmail.vue";
import {useHead} from "@vueuse/head";


const route = useRoute()
const detail = ref(null)


function get_detail(title) {
  let url = '/api/blogs/?site='
  url = url + title
  axios
      .get(url)
      .then(response => {
        detail.value = response.data.results[0]
      })
      .catch(error => {
        console.log(error)
      })
}

function formatDate(dateString) {
  const date = new Date(dateString);
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
}


onMounted(async () => {
  const scripts = [
      '/assets/js/vendor/modernizr-2.8.3.min.js',
    '/assets/js/vendor/jquery-3.5.1.min.js',
    '/assets/js/bootstrap.min.js',
    '/assets/js/isotope.pkgd.min.js',
    '/assets/js/owl.carousel.min.js',
    '/assets/js/jquery.nivo.slider.pack.js',
    '/assets/js/slick.min.js',
    '/assets/js/imagesloaded.pkgd.min.js',
    '/venobox/venobox.min.js',
    '/assets/js/jquery.appear.js',
    '/assets/js/jquery.knob.js',
    '/assets/js/BeerSlider.js',
    '/assets/js/theme-pluginjs.js',
    '/assets/js/jquery.meanmenu.js',
    '/assets/js/ajax-mail.js',
    '/assets/js/theme.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  await loadScriptsSequentially(scripts);
  const title = route.params.str
  await get_detail(title)
})

watch(detail, (newVal) => {
  if (newVal) {
    useHead({
      title: newVal.blog_title,
      meta: [
        {
          name: 'keywords',
          content: newVal.blog_title
        },
        {
          name: 'description',
          content: newVal.blog_title
        }
      ]
    })
  }
})

</script>

<template>
  <Header/>

  <!-- breadcumb-area -->
  <div class="breadcumb-area">
    <div class="container">
      <div class="row">
        <div class="col-md-12 txtc  text-center ccase">
          <div class="brpt">
            <h2>Single Blog</h2>
          </div>
          <div class="breadcumb-inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><i class="fas fa-angle-right"></i></li>
              <li>Single Blog</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- BLOG AREA -->
  <div class="witr-blog-side-area  blog_area single_blog ">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-7 col-sm-12">
          <!-- SINGLE BLOG -->
          <div class="single_blog single_blog_grid singles">
            <div class="single_blog_thumb" style="text-align: center;">
              <img v-if="detail" :src="detail.image_1" alt="">
            </div>
            <!-- BLOG TITLE -->
            <div class="kurigram-single-blog-details-inner">
              <div class="kurigram-single-blog-title">
                <h2 v-if="detail">{{ detail.blog_title }}</h2>
              </div>
              <div class="kurigram-blog-meta">
                <div class="kurigram-blog-meta-left">
                  <span v-if="detail"><i class="fas fa-calendar-alt"></i>{{ formatDate(detail.updated_at) }}</span>
                </div>
              </div>
              <div class="kurigram-single-blog-content">
                <div class="single-blog-content">
                  <p v-if="detail" v-html="detail.content"></p>
                </div>
              </div>
              <div class="kurigram-blog-social">
                <div class="kurigram-single-icon">
                  <div class="kurigram-single-icon-inner">
                    <a href="https://www.facebook.com/profile.php?id=100083074701518"><i
                        class="fa fa-facebook-f"></i></a>
                    <a href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw"><i
                        class="fab fa-youtube"></i></a>
                    <a href="https://www.linkedin.com/company/84045662/admin/"><i class="fab fa-linkedin"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <BlogsEmail/>
        </div>

      </div>
    </div>
  </div>

  <Footer/>
</template>

<style scoped lang="scss">

</style>